<script setup>
import { computed, useId } from 'vue';

const props = defineProps({
  label: { type: String, default: '' },
  helper: { type: String, default: '' },
  error: { type: String, default: '' },
  required: { type: Boolean, default: false },
  controlId: { type: String, default: '' },
  grouped: { type: Boolean, default: false },
});

const generatedId = useId();
const labelId = computed(
  () => `${props.controlId || `agent-field-${generatedId}`}-label`
);
const descriptionId = computed(
  () => `${props.controlId || `agent-field-${generatedId}`}-description`
);
const hasDescription = computed(() => Boolean(props.error || props.helper));
</script>

<template>
  <component
    :is="grouped ? 'fieldset' : 'div'"
    class="flex min-w-0 flex-col gap-1.5 text-sm text-n-slate-12"
    :aria-describedby="grouped && hasDescription ? descriptionId : undefined"
  >
    <component
      :is="grouped ? 'legend' : controlId ? 'label' : 'span'"
      v-if="label"
      :id="labelId"
      :for="!grouped && controlId ? controlId : undefined"
      class="font-medium leading-tight text-n-slate-12"
    >
      {{ label }}
      <span
        v-if="required"
        class="ml-0.5 text-n-ruby-9 before:content-['*']"
        aria-hidden="true"
      />
    </component>

    <slot
      :label-id="labelId"
      :description-id="hasDescription ? descriptionId : undefined"
      :has-error="Boolean(error)"
    />

    <span
      v-if="error"
      :id="descriptionId"
      class="text-xs leading-tight text-n-ruby-11"
      role="alert"
    >
      {{ error }}
    </span>
    <span
      v-else-if="helper"
      :id="descriptionId"
      class="text-xs leading-tight text-n-slate-11"
    >
      {{ helper }}
    </span>
  </component>
</template>
